module.exports = __webpack_public_path__ + "public/img/5.4d1519f3.png";